import React from 'react';
import {
    HandleChangeVisible,
    IFormPresentation,
    Metadata,
    SelectDisplayType,
    SelectValue
} from '../../../schema/interface';
import Checkbox from './Checkbox';
import DropDownMulti from './DropDownMulti';
import ToggleMultiSelect from './ToggleMultiSelect';
import OtherOptionInput from './OtherOptionInput';
import useMultiSelect from '../../../hooks/multiSelect';

interface ISelectController {
    metadata: Metadata;
    presentation: IFormPresentation;
    name: string;
    value: SelectValue;
    handleChangeVisible: HandleChangeVisible;
    formValues: { [key: string]: string | string[] | SelectValue };
    noAccess?: boolean;
}
const MultiSelect = ({
    metadata,
    presentation,
    name,
    value,
    handleChangeVisible,
    formValues,
    noAccess
}: ISelectController) => {
    const { displayType, required } = presentation;
    const { min, max, items, separator, restricted } = metadata;
    const {
        handleInputChange,
        errorOtherOption,
        validatedOtherOption,
        otherOptionValue,
        ...props
    } = useMultiSelect({
        items,
        separator,
        restricted,
        value,
        name,
        min,
        max,
        required,
        handleChangeVisible,
        formValues
    });
    const otherOption =
        restricted === false ? (
            <OtherOptionInput
                name={name}
                value={otherOptionValue}
                handleInputChange={handleInputChange}
                handleOnBlur={validatedOtherOption}
                errorOtherOption={errorOtherOption}
                isEnabled={restricted === false}
                required={min !== 0 && required && !value?.choices?.length}
                noAccess={noAccess}
            />
        ) : null;
    let select;

    if (displayType === SelectDisplayType.Dropdown) {
        select = (
            <DropDownMulti {...props} otherOptionValue={otherOptionValue} noAccess={noAccess} />
        );
    } else if (displayType === SelectDisplayType.Checkbox || presentation?.selectType === 2) {
        select = (
            <Checkbox
                {...props}
                presentation={presentation}
                otherOptionValue={otherOptionValue}
                noAccess={noAccess}
            />
        );
    } else if (displayType === SelectDisplayType.Toggle) {
        select = (
            <ToggleMultiSelect {...props} otherOptionValue={otherOptionValue} noAccess={noAccess} />
        );
    }

    return (
        <>
            {select}
            {otherOption}
        </>
    );
};
export default MultiSelect;
